// # Enhanced Loading spinner component
import React from 'react';
import { BiLoaderAlt } from 'react-icons/bi';
import './Loading.css';

function Loading({ message = "Loading...", size = "default" }) {
  // # Add size prop for flexible spinner sizing
  return (
    <div className="loading-container">
      {/* # Option 1: Custom CSS spinner */}
      <div className="loading-spinner"></div>
      
      {/* # Option 2: Using React Icons (commented out but available) */}
      {/* <BiLoaderAlt 
        className="loading-spinner" 
        size={size === "small" ? 50 : 80} 
      /> */}
      
      <p className="loading-text">{message}</p>
    </div>
  );
}

export default Loading; 